import React from 'react';
import styled from 'styled-components';

import theme from '../../theme';

interface CheckboxCustomizadoProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const Wrapper = styled.label`
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const LabelText = styled.span`
  font-size: 12px;
  color: ${theme.colors.padraoAzulEscuro};
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const StyledCheckbox = styled.span<{ checked: boolean }>`
  width: 32px;
  height: 32px;

  border: 2px solid;
  border-color: ${({ checked, theme }) =>
    checked ? theme.colors.azulgov : '#a1a1a1'};
  border-radius: 10px;
  background-color: ${({ checked, theme }) =>
    checked ? theme.colors.azulgov : 'lightgray'};
  display: inline-block;
  transition: background-color 0.2s ease;
  position: relative;
  margin-top: 10px;
  /* margin-bottom: 1px; */
  &::after {
    content: '';
    position: absolute;
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    top: 5px;
    left: 10px;
    width: 8px;
    height: 15px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

const CheckboxCustomizado: React.FC<CheckboxCustomizadoProps> = ({
  label,
  checked,
  onChange,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <Wrapper>
      <LabelText>{label}</LabelText>
      <div style={{ position: 'relative' }}>
        <HiddenCheckbox checked={checked} onChange={handleInputChange} />
        <StyledCheckbox checked={checked} />
      </div>
    </Wrapper>
  );
};

export default CheckboxCustomizado;
